// export const authRoles = {
//     sa: ['SA'], // Only Super Admin has access
//     admin: ['SA', 'ADMIN'], // Only SA & Admin has access
//     editor: ['SA', 'ADMIN', 'EDITOR'], // Only SA & Admin & Editor has access
//     guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST'], // Everyone has access
// }

export const authRoles = Object.freeze({
	admin: 'A',
	housingCooper: 'S',
	careTaker: 'D',
	owner: 'O'
})

export const rolesAll = [authRoles.admin, authRoles.housingCooper, authRoles.careTaker, authRoles.owner]

export const accessRights = Object.freeze({
	admin: [authRoles.admin], // Only Admin has access
	housingCooper: [authRoles.admin, authRoles.housingCooper], // Only Admin & HousingCooper has access
	careTaker: [authRoles.admin, authRoles.housingCooper, authRoles.careTaker], // Only Admin & HousingCooper & CareTaker has access
	owner: [authRoles.admin, authRoles.housingCooper, authRoles.careTaker, authRoles.owner], // Only Admin & HousingCooper & CareTaker & Owner has access
	anyRole: rolesAll // Anyone with some role has access
})

export const authRoleName = (authRoleId) => {
	let role = ''

	switch (authRoleId) {
		case authRoles.housingCooper: {
			role = 'Správca'
			break
		}
		case authRoles.admin: {
			role = 'Admininistrátor'
			break
		}
		case authRoles.owner: {
			role = 'Vlastník'
			break
		}
		case authRoles.careTaker: {
			role = 'Domovník'
			break
		}
		default:
			role = 'Neznáma rola'
			break
	}
	return role
}

export const doByAuthRole = (role, { onAdmin, onHousingCooper, onCareTaker, onOwner, onOther }) => {
	switch (role) {
		case authRoles.admin:
			return onAdmin?.() || onOther?.()
		case authRoles.housingCooper:
			return onHousingCooper?.() || onOther?.()
		case authRoles.careTaker:
			return onCareTaker?.() || onOther?.()
		case authRoles.owner:
			return onOwner?.() || onOther?.()
		default:
			return onOther?.()
	}
}

// Check out app/views/dashboard/DashboardRoutes.js
// Only SA & Admin has dashboard access

// const dashboardRoutes = [
//   {
//     path: "/dashboard/analytics",
//     component: Analytics,
//     auth: authRoles.admin <===============
//   }
// ];

// Check navigaitons.js

// {
//   name: "Dashboard",
//   path: "/dashboard/analytics",
//   icon: "dashboard",
//   auth: authRoles.admin <=================
// }
